import { AnimatePresence, motion } from "framer-motion";
import ExamCard from "./ExamCard/ExamCard";
import { useContext, useEffect, useMemo } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";
import sortExamList from "../../../Util/functions/ExamCreatorHelperFunctions/sortExamList";
import addHeadersToExamArray from "../../../Util/functions/ExamCreatorHelperFunctions/addHeadersToExamArray";
import { ExamCreatorContext } from "../../../Util/contexts/ExamCreatorContext";
import filterExamList from "../../../Util/functions/ExamCreatorHelperFunctions/filterExamList";
import { examCreatorListMotionProps } from "../../../Util/animations/Animations_v2";
import ExamListLoader from "./ExamListLoader";
import SectionHeader from "./SectionHeader";

const ExamList = ({ selectedExamId, setSelectedExamId }) => {
  const { userData, premadeExams, customExams, reviewLaterExams } =
    useContext(AppContext);
  const {
    sortBy,
    isCaseListAscending,
    isHideCompletedChecked,
    isHideIncompleteChecked,
    searchTerm,
    examListView,
    loadingExamList,
  } = useContext(ExamCreatorContext);

  useEffect(() => {
    document.getElementById("caseListBodyPageWrapper").scrollTo(0, 0);
  }, []);

  const filteredExams = useMemo(
    () =>
      filterExamList(
        examListView === "Premade Exams" ? premadeExams : customExams,
        searchTerm,
        isHideCompletedChecked,
        isHideIncompleteChecked
      ),
    // eslint-disable-next-line
    [
      searchTerm,
      isHideCompletedChecked,
      isHideIncompleteChecked,
      premadeExams,
      customExams,
    ]
  );
  const sortedExams = useMemo(
    () =>
      sortExamList(
        filteredExams,
        sortBy,
        isCaseListAscending,
        reviewLaterExams
      ),
    [filteredExams, sortBy, isCaseListAscending, reviewLaterExams]
  );
  const examListWithHeaders = useMemo(
    () =>
      addHeadersToExamArray(
        sortedExams,
        isCaseListAscending,
        sortBy,
        reviewLaterExams
      ),
    [sortedExams, isCaseListAscending, sortBy, reviewLaterExams]
  );

  return (
    <motion.div
      key={"Exam List Body"}
      {...examCreatorListMotionProps(userData.AnimationsDisabled)}
    >
      <AnimatePresence mode="wait">
        {loadingExamList ? (
          <ExamListLoader />
        ) : (
          <AnimatePresence mode="wait">
            <motion.div
              className="caseListContainer"
              {...examCreatorListMotionProps(userData.AnimationsDisabled)}
              key={"CaseListPremadeCardContainer"}
            >
              {examListWithHeaders.map((value, index) =>
                value.type ? (
                  <SectionHeader
                    key={`Section Header - ${value.sectionId} - ${index}`}
                    {...value}
                  />
                ) : (
                  <ExamCard
                    key={`Premade Exam Card - ${value.examId} - ${index}`}
                    selectedExamId={selectedExamId}
                    setSelectedExamId={setSelectedExamId}
                    examData={value}
                    examListView={examListView}
                  />
                )
              )}
              {examListWithHeaders.length === 0 && (
                <div className="caseListNoCasesContainer">
                  <h3 className="caseListCaseTitle caseListNoCasesTitle">
                    No Exams Match Your Search
                  </h3>
                  <p className="caseListCaseDiagnosisText caseListNoCasesText">
                    It looks like we don't have any exams matching your search.
                    Try expanding your search by adding categories or changing
                    your search input.
                  </p>
                </div>
              )}
            </motion.div>
          </AnimatePresence>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default ExamList;
